import React, { useContext } from 'react';
import styles from './links.module.scss';
import { trackClientExternalLink } from '../../analytics/client-event-tracking';
import { AccountContext } from '../../contexts';

function LinksRow({links}) {
    const account = useContext(AccountContext);

    const trackPromoLinkClick = ({label, link_url, position}) => {
        trackClientExternalLink(account, {
            unit_type: 'feed',
            unit_name: 'main',
            item_type: 'text',
            item_name: label,
            position_in_unit: position,
            target_content_url: link_url,
        });
    };

    return (
        <div className={styles.linkRow}>
            {links.map((link, i) =>
                <a
                    key={i}
                    href={link.link_url}
                    className={styles.linkBlock}
                    onClick={() => trackPromoLinkClick(link)}
                >
                    <span className={styles.emoji}>{link.emoji}</span>
                    <span dangerouslySetInnerHTML={{__html: link.label}} />
                </a>
            )}
        </div>
    );
}

export default LinksRow;
